module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race"
  }, [_c('div', {
    staticClass: "race__inner"
  }, [_c('vue-audio', {
    ref: "raceTextStart",
    attrs: {
      "file": 6
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "race__info"
  }, [_c('div', {
    staticClass: "race__info__inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "race__info__row"
  }, [_c('div', {
    staticClass: "main-score"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("あなたのユニコーン")]), _vm._v(" "), _c('span', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.finalDistanceA) + "M")])]), _vm._v(" "), _c('div', {
    staticClass: "com-score"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("競争相手のユニコーン")]), _vm._v(" "), _c('span', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.finalDistanceB) + "M")])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "race__street"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "race__content"
  }, [_c('horse', {
    attrs: {
      "id": "user"
    }
  }), _vm._v(" "), _c('horse', {
    attrs: {
      "id": "pc"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "race__dice"
  }, [_c('match-dice', {
    attrs: {
      "isGoal": _vm.isGoal
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "race__text"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRaceTextStart),
      expression: "showRaceTextStart"
    }],
    staticClass: "race__text__start"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/text_start.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRaceTextGoal),
      expression: "showRaceTextGoal"
    }],
    staticClass: "race__text__goal"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/text_goal.png"),
      "alt": ""
    }
  })])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race__info__row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("サイコロを振って競争しよう！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race__meter"
  }, [_c('span', {
    staticClass: "meter"
  }, [_vm._v("2000M")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "street__background"
  }, [_c('p', {
    staticClass: "start"
  }), _vm._v(" "), _c('p', {
    staticClass: "goal"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec3594d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RaceScreen.vue
// module id = 87
// module chunks = 0